var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"systemHeader"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/img/logo.png"),"alt":""}}),_c('h1',{staticClass:"sys_name"},[_vm._v("熊猫热点")]),_c('p',{staticClass:"title_"},[_vm._v("PandaMobo旗下产品 海外媒体一站式数据服务平台")])])
}]

export { render, staticRenderFns }